module.exports = __webpack_public_path__ + "static/Syberia0-1a1df70558954c021734fd851084aa9e.webp";